import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Section, Wrapper, SectionHead } from "../SectionHead";
import { fadeUp, scaleIn, viewportOnce } from "../../utils/motion";
import { skills } from "../../data/constants";

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
`;

const Card = styled(motion.div)`
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  padding: 26px 24px;
  transition: transform 0.3s ease, border-color 0.3s ease, background 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: rgba(139, 124, 255, 0.35);
    background: rgba(255, 255, 255, 0.05);
  }
`;

const CardTitle = styled.h3`
  font-family: "Space Grotesk", sans-serif;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.text_muted};
  margin-bottom: 18px;
`;

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const Item = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.07);
  color: ${({ theme }) => theme.text_primary};
  font-size: 13.5px;
  font-weight: 500;
  transition: border-color 0.25s ease, background 0.25s ease, transform 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.primary};
    background: rgba(139, 124, 255, 0.1);
    transform: translateY(-2px);
  }
`;

const IconBadge = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
`;

const Icon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const Skills = () => {
  return (
    <Section id="skills" style={{ scrollMarginTop: 96 }}>
      <Wrapper>
        <SectionHead
          eyebrow="Skills & Tools"
          title="Languages, frameworks, and infrastructure I use regularly."
          subtitle="Picked up and kept sharp over 7+ years of building and running production software."
        />

        <Grid>
          {skills.map((group, i) => (
            <Card
              key={group.title}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={viewportOnce}
              custom={i}
            >
              <CardTitle>{group.title}</CardTitle>
              <List>
                {group.skills.map((item, j) => (
                  <Item
                    key={item.name}
                    variants={scaleIn}
                    initial="hidden"
                    whileInView="visible"
                    viewport={viewportOnce}
                    custom={j}
                  >
                    <IconBadge>
                      <Icon src={item.image} alt="" loading="lazy" />
                    </IconBadge>
                    {item.name}
                  </Item>
                ))}
              </List>
            </Card>
          ))}
        </Grid>
      </Wrapper>
    </Section>
  );
};

export default Skills;
